// import Vue from 'vue'
// import consts from "@/consts"
// import range from "lodash/range";
import {getApiProps, updateObjectByDiff} from "@/lib/lib";
// import {arraySplitIntoChunks} from "@/lib/lib";

const with_removed = String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}
// const changedField = 'changed__time';

const collator = new Intl.Collator();
const sortByName = function (a, b) {
    let cmp = collator.compare(a?.name_ || '', b?.name_ || '')
    if (cmp) {
        return cmp;
    }
    return a.id - b.id;
}

export default {
    state: {
        greenseesDevicesFullLoad: false,
        greenseesDevicesLiteLoad: false,
        greenseesDevices: [],
    },
    actions: {
        fetchGreenseesDevices/*all*/({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchGreenseesDevices', args, time: Date.now() / 1000})

                const params = getApiProps('greenseesDevices', args)
                this.$api.greenseeDevices.getAll({...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            commit('updateGreenseesDevices', response.data)
                            commit('setGreenseesDevicesLiteLoad', true)
                            commit('setGreenseesDevicesFullLoad', true)
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchGreenseesDevices', args, inprogress: false})
                    });
            })
        },

        saveGreenseesDevice({dispatch}, device) {
            let fn = (device.id) ? 'updateGreenseesDevice' : 'createGreenseesDevice'
            return dispatch(fn, device);
        },
        createGreenseesDevice({commit}, device) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('greenseesDevices')
                this.$api.greenseeDevices.create(device, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            commit('updateGreenseesDevice', response.data)
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        updateGreenseesDevice({commit}, device) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('greenseesDevices')
                this.$api.greenseeDevices.update(device.id, device, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            commit('updateGreenseesDevice', response.data)
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        deleteGreenseesDevice({commit}, id) {//remove
            return new Promise((resolve, reject) => {
                const params = getApiProps('greenseesDevices')
                this.$api.greenseeDevices.delete(id, {...params, ...with_removed})//remove
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data.error)) {
                            if (!response.data) commit('deleteGreenseesDevice', id)
                            else commit('updateGreenseesDevice', response.data)
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
    },
    mutations: {
        setGreenseesDevicesFullLoad(state, FullLoad) {
            state.greenseesDevicesFullLoad = state.greenseesDevicesFullLoad || FullLoad
        },
        setGreenseesDevicesLiteLoad(state, LitaLoad) {
            state.greenseesDevicesLiteLoad = state.greenseesDevicesLiteLoad || LitaLoad
        },

        setGreenseesDevices(state, nGreenseesDevices) {
            nGreenseesDevices = nGreenseesDevices.map(u => {
                if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                return u //Object.freeze(u)
            })
            nGreenseesDevices.sort(sortByName)
            state.greenseesDevices = nGreenseesDevices
        },

        updateGreenseesDevices(state, nGreenseesDevices) {
            if (!state.greenseesDevices.length) {
                nGreenseesDevices = nGreenseesDevices.map(u => {
                    if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                    return u //Object.freeze(u)
                })
                nGreenseesDevices.sort(sortByName)
                state.greenseesDevices = nGreenseesDevices
                // const chunks = arraySplitIntoChunks(nGreenseesDevices)//.reverse();
                // const pushOnRenderTask = () => {
                //     if (chunks.length === 0) return;
                //     let chunk = chunks.pop();
                //     state.greenseesDevices.push(...chunk);
                //     setTimeout(() => {
                //     requestAnimationFrame(pushOnRenderTask);
                //     }, 300)
                //     //this.$nextTick().then(() => pushOnRenderTask())
                // }
                // pushOnRenderTask();
                return true
            }

            nGreenseesDevices.forEach(function (nDevice) {
                if (nDevice?.name) nDevice.name_ = nDevice.name.toLocaleLowerCase()
                let i = state.greenseesDevices.findIndex(u => (u.id == nDevice.id))
                if (i < 0) {
                    state.greenseesDevices.push(nDevice) //(Object.freeze(nDevice))
                } else {
                //if (!state.greenseesDevicesFullLoad || state.greenseesDevices[i][changedField] != nDevice[changedField]) {
                    updateObjectByDiff(state.greenseesDevices[i], nDevice)
                    // delete nDevice.id
                    // nDevice = {...state.greenseesDevices[i], ...nDevice}
                    // state.greenseesDevices[i] = nDevice //Object.freeze(nDevice)
                }
            })

        },
        filterGreenseesDevices(state, nGreenseesDevices) {
            // let Ids = state.greenseesDevices.map(u=> u.id)
            let nIds = nGreenseesDevices.map(u => u.id)
            let removedIds = state.greenseesDevices.filter(u => !nIds.includes(u.id)).map(u => u.id)
            removedIds.forEach(removedId => {
                let i = state.greenseesDevices.findIndex(u => (u.id == removedId))
                if (i != -1) {
                    state.greenseesDevices.splice(i, 1)
                }
            })
        },
        updateGreenseesDevice(state, nDevice) {
            if (nDevice?.name) nDevice.name_ = nDevice.name.toLocaleLowerCase()
            let i = state.greenseesDevices.findIndex(u => (u.id == nDevice.id))
            if (i < 0) {
                state.greenseesDevices.push(nDevice) //(Object.freeze(nDevice))
            } else {
            //if (!state.greenseesDevicesFullLoad || state.greenseesDevices[i][changedField] != nDevice[changedField]) {
                updateObjectByDiff(state.greenseesDevices[i], nDevice)
                // delete nDevice.id
                // nDevice = {...state.greenseesDevices[i], ...nDevice}
                // state.greenseesDevices[i] = nDevice //Object.freeze(nDevice)
            }
        },
        deleteGreenseesDevice(state, id) {
            let i = state.greenseesDevices.findIndex(u => (u.id == id))
            if (i != -1) {
                state.greenseesDevices.splice(i, 1)
            }
        },

        clearGreenseesDevices(state) {
            state.greenseesDevices = []
            state.greenseesDevicesFullLoad = false
            state.greenseesDevicesLiteLoad = false
        },
    },
    getters: {
        isGreenseesDevicesFullLoad(state) {
            return state.greenseesDevicesFullLoad
        },
        isGreenseesDevicesLiteLoad(state) {
            return state.greenseesDevicesLiteLoad
        },
        getGreenseesUnits(state, getters) {
            return state.greenseesDevices.map(d => getters.getUnitsByIds[d.id]).filter(v => v)
        },
        getGreenseesAvailableUnits(state, getters) {
            return state.greenseesDevices
                .filter(d => !d?.uncompleted?.length)
                .map(d => getters.getUnitsByIds[d.id])
        },
    }
}
